import { describeResponseBody, makeRequest } from "../../lib/utils"

import { getFewsWebServicesUrl, getRainsatProxyApiUrl } from "../environment"

import { catchMessage } from "./errors"

export const fetchLocalFile = (path, type) => async (dispatch) => {
  return await fetch(path)
    .then(response => type === "json" ? response.json() : response.text())
    .then(content => {
      return content
    })
    .catch(function (error) {
      dispatch(catchMessage({ exception: error }, "fetchLocalFile"))
    })
}

export const GetLocations = (signal, token, parameters, body) => async (dispatch) => {
  const url = `${getRainsatProxyApiUrl()}/fews/locations?showTimeSeriesInfo=true&documentFormat=GEO_JSON`

  try {
    const response = await makeRequest(url, "GetLocations", "GET", signal, token, parameters, body)

    if (!response) throw new Error("No response")

    // Pass the whole response so catchMessage still sees the HTTP status
    if (response.exception) {
      dispatch(catchMessage(response, "GetLocations"))
      return null
    }

    try {
      return JSON.parse(response)
    } catch (error) {
      throw new Error(describeResponseBody(response) || error.message)
    }
  } catch (error) {
    dispatch(catchMessage({ exception: error }, "GetLocations"))
  }
}

export const GetTimeseries = (signal, token, parameters, body) => async (dispatch) => {
  // claude: startTime/endTime toegevoegd — zonder deze parameters gebruikt FEWS de server-geconfigureerde
  // view period (vaak slechts enkele uren), waardoor historische observaties en forecast niet terugkwamen.
  // Bereik -10d/+7d dekt observations (10d terug), nowcast (+6u) en forecast (+7d).
  const toFewsTime = (ms) => new Date(ms).toISOString().slice(0, 19) + 'Z'
  const startTime = toFewsTime(Date.now() - 10 * 24 * 60 * 60 * 1000)
  const endTime = toFewsTime(Date.now() + 7 * 24 * 60 * 60 * 1000)

  const url = `${getRainsatProxyApiUrl()}/fews/timeseries?locationIds=${parameters.locationId}&startTime=${encodeURIComponent(startTime)}&endTime=${encodeURIComponent(endTime)}&documentFormat=PI_JSON`

  try {
    const response = await makeRequest(url, "GetTimeseries", "GET", signal, token, parameters, body)

    if (!response) throw new Error("No response")

    // Pass the whole response so catchMessage still sees the HTTP status
    if (response.exception) {
      dispatch(catchMessage(response, "GetTimeseries"))
      return null
    }

    try {
      return JSON.parse(response)
    } catch (error) {
      throw new Error(describeResponseBody(response) || error.message)
    }
  } catch (error) {
    dispatch(catchMessage({ exception: error }, "GetTimeseries"))
  }
}